<template>
  <div class="report">
    <div class="check-box" style="overflow: hidden;">
      <el-row :gutter="0">
        <el-col :span="6">
          <div class="check-info" style="float: left; ">

            <div class="left" style="margin-right: 50px;">
              <span>报告类型：</span>

              <el-select v-model="formInline.type" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <el-col :span="12" style="    display: flex; justify-content: center; align-items: center;">
          <el-breadcrumb separator-class="el-icon-arrow-right" style="float: left;width: 300px;">
            <el-breadcrumb-item v-if="formInline.type==1"
              style="font-size: 23px;">{{(formInline.date.split("-")[0]+"-"+formInline.date.split("-")[1]+"月")}}报告</el-breadcrumb-item>
            <el-breadcrumb-item v-if="formInline.type==2"
              style="font-size: 23px;">{{(formInline.date.split("-")[0]+"年")}}报告</el-breadcrumb-item>
            <el-breadcrumb-item v-if="formInline.type==3"
              style="font-size: 23px;">{{(formInline.date.split("-")[0]+"年1-6月")}}报告</el-breadcrumb-item>
            <el-breadcrumb-item v-if="formInline.type==4"
              style="font-size: 23px;">{{(formInline.date.split("-")[0]+"年7-12月")}}报告</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
        <el-col :span="6">
          <div class="check-info" style="float: right; ">

            <div class="right" style="margin-right: 50px;">
              <span>日期选择：</span>
              <el-date-picker :key="formInline.type" :picker-options="pickerOptions" v-model="formInline.date"
                :type="formInline.type | dateType" :value-format="formInline.type | dateFormat" placeholder="请选择日期">
              </el-date-picker>
            </div>

            <el-button type="primary" icon="el-icon-download" class="right"
              @click="exportExcelDataStatement">导出</el-button>
          </div>
        </el-col>

      </el-row>





      <el-row
        style="clear: both;width: 100%; padding-top: 10px;display: flex;justify-content: center; align-items: center;">
        <el-button type="primary" plain :style="buttonStyle0" @click="open(0)">总体概览</el-button>
        <el-button type="primary" :style="buttonStyle1" @click="open(1)" plain>用电统计</el-button>
        <el-button type="primary" :style="buttonStyle2" @click="open(2)" plain>用电分析</el-button>
        <el-button type="primary" :style="buttonStyle3" @click="open(3)" plain>事件统计</el-button>
      </el-row>
    </div>

    <ztgy :date="formInline.date" :dateType="formInline.type" v-if="page == 0"></ztgy>
    <ydtj :date="formInline.date" :dateType="formInline.type" v-if="page == 1"></ydtj>
    <ydfx :date="formInline.date" :dateType="formInline.type" v-if="page == 2"></ydfx>
    <sjtj :date="formInline.date" :dateType="formInline.type" v-if="page == 3"></sjtj>

    <el-dialog :visible.sync="dialogTableVisible" v-if="dialogTableVisible" show-close :close-on-click-modal="false"
      width="775px">
      <pdf :date="formInline.date" :dateType="formInline.type"></pdf>
    </el-dialog>
  </div>

</template>

<script>
  import tool from "../utils/tool";
  import ztgy from "../components/monthReportPage/ztgytab";
  import ydtj from "../components/monthReportPage/ydtj";
  import ydfx from "../components/monthReportPage/ydfx";
  import sjtj from "../components/monthReportPage/sjtj";
  import pdf from "../components/monthReportPage/pdf";
  export default {
    data () {
      return {
        options: [{
          value: 1,
          label: '月报告'
        }, {
          value: 2,
          label: '年报告'
        }, {
          value: 3,
          label: '上半年报告'
        }, {
          value: 4,
          label: '下半年报告'
        }],
        dialogTableVisible: false,
        timeTypeIndex: 1,
        formInline: {
          type: 1,
          date: tool.formatDate("yyyy-MM-dd", new Date(new Date().setMonth(new Date().getMonth() - 1)))
        },
        pickerOptions: {
          firstDayOfWeek: 1,
          disabledDate (time) {
            return time.getTime() > new Date().setMonth(new Date().getMonth() - 1);
          },
        },
        buttonStyle0: "width: 20%;",
        buttonStyle1: "width: 20%;",
        buttonStyle2: "width: 20%;",
        buttonStyle3: "width: 20%;",
        page: 0
      };
    },
    components: {
      ztgy,
      ydtj,
      ydfx,
      sjtj,
      pdf
    },
    created () {
      this.open(0)
    },
    watch: {
      "formInline.date" (v) {
        this.page = 9
        this.$nextTick(() => {
          this.open(0)
        })
      },
      "formInline.type" (v) {
        const month = this.formInline.date.split("-")[1]
        if (month == undefined) {
          this.formInline.date = this.formInline.date.split("-")[0] + "-" + "01"
        }

        this.page = 9

        this.$nextTick(() => {
          this.open(0)
        })
      }
    },
    filters: {
      dateType (v) {
        // // console.log(v)
        let type = {
          0: "date",
          1: "month",
          2: "year",
          3: "year",
          4: "year",
        };
        return type[v];
      },
      dateFormat (v) {
        let type = {
          0: "yyyy-MM-dd",
          1: "yyyy-MM",
          2: "yyyy",
          3: "yyyy",
          4: "yyyy",
        };
        return type[v];
      },
    },
    methods: {
      exportExcelDataStatement () {
        this.dialogTableVisible = true
      },
      open (item) {
        this.buttonStyle(item)
      },
      buttonStyle (item) {
        this.page = item
        for (var i = 0; i < 4; i++) {
          if (item == i) {
            eval("this.buttonStyle" + i + "='width: 20%;background: #409EFF;color: white;'")
          } else {
            eval("this.buttonStyle" + i + "='width: 20%;'")
          }
        }
      }
    },
  };
</script>

<style lang="less">
  .report {
    .check-box {
      padding: 20px;
      padding-bottom: 0;
      box-sizing: border-box;
      background: #f8f8f9;



      .check-info {

        display: flex;
        position: relative;

        >div {
          span {
            font-size: 16px;
            font-weight: 600;
            text-align: right;

          }
        }

        .left {
          margin-right: 40px;
          display: flex;
          align-items: center;

          .el-select {
            width: 200px;
          }
        }
      }
    }

    .el-dialog__headerbtn {
      z-index: 10000;
    }

  }
</style>